import { getApiURL, getSessionId } from 'utils/utils';
import axios from 'axios';

const instance = axios.create({
  // baseURL: 'http://localhost:9781',
  baseURL: getApiURL(),
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

// body('from').isMongoId(),
//   body('to').isMongoId(),
//   body('type').isIn(Object.values(MODULE_TYPE)),
//   body('answers').isArray(),
//   body('answers.*.questionId').isMongoId(),
//   body('answers.*.text').isString().optional(),
export const updateReview = (params) =>
  instance.post(`/web-app/user/cycles/reviews/update`, params, {
    headers: {
      sessionId: getSessionId(),
    },
  });

//retrieve reviews for a cycle
export const retrieveReviewsForCycle = (params) =>
  instance.post(`/web-app/user/cycles/reviews/retrieve`, params, {
    headers: {
      sessionId: getSessionId(),
    },
  });

//submit review
export const submitReview = (params) =>
  instance.post(`/web-app/user/cycles/reviews/submit`, params, {
    headers: {
      sessionId: getSessionId(),
    },
  });

// router.post('/retrieve-context', [
//   body('from').isMongoId(),
//   body('to').isMongoId(),
//   body('type').isIn([MODULE_TYPE.DOWNWARD])
export const retrieveContextReview = (params) =>
  instance
    .post(`/web-app/user/cycles/reviews/retrieve-context`, params, {
      headers: {
        sessionId: getSessionId(),
      },
    })
    .then(({ data }) => data);

export const releaseReviews = (params) =>
  instance
    .post(`/web-app/user/cycles/reviews/release`, params, {
      headers: {
        sessionId: getSessionId(),
      },
    })
    .then(({ data }) => data);
